<template>
  <OmtLayoutContainer>
    <OmtRow>
      <OmtTypography mb="24px" as="h1-bold"> Programa {{ $route.query.programa }} </OmtTypography>
    </OmtRow>

    <OmtRow>
      <OmtTypography mb="8px" as="p1">Descreva aqui a sua dúvida ou a informação que você precisa:</OmtTypography>
    </OmtRow>

    <OmtRow>
      <CFlex flexDirection="column" alignItems="flex-end">
        <OmtTextarea
          class="input-observation"
          height="109px"
          padding="12px"
          placeholder="Inclua informações ou detalhes que podem complementar os documentos enviados."
          :initialValue="description"
          maxlength="500"
          @change="handleChange"
        />
        <OmtTypography as="p2"> {{ description.length }}/500 </OmtTypography>
      </CFlex>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['342px !important']" :disabled="description.trim().length === 0"
@click="goToNextPage">
        Enviar
      </OmtButton>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "ProgramasSaudeRevision",
  data() {
    return {
      description: ""
    };
  },
  methods: {
    ...mapMutations("programasSaude", ["SET_NEW_SOLICITATION"]),
    goToNextPage() {
      this.SET_NEW_SOLICITATION({ observacao: this.description.slice(0, 500) });
      this.$router.push({ name: "programas-saude-upload" });
    },
    handleChange(obs) {
      this.description = obs;
    }
  },
  async mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
::v-deep .input-observation {
  border: 0.5px solid #dadada;
  color: #8c8c8c !important;
}

::v-deep .input-observation::placeholder {
  color: #8c8c8c !important;
}
</style>
